// extracted by mini-css-extract-plugin
export default {"container":"CustomerStatement_container__8TTKD","header":"CustomerStatement_header__WZZNT","statement":"CustomerStatement_statement__egfPq"};